<script>
    import Metrics from '../../components/Metrics.svelte'
</script>
  
  <div class="notifications">
    <div class="columns">
      <div class="column">
        <div class="content">
          <Metrics />
        </div>
      </div>
    </div>
  </div>
  